// Industry factor tables — rules/RULES_INDUSTRIAL.md §2 and §3.
//
// Two tables, both kept small and explicit:
//   - INDUSTRY_ORIENTATION_FACTORS maps the binary "qualified vs other"
//     choice. The actual trigger is `BuildingItem.isIndustryOriented`
//     + project-type exclusion + supporting-commercial exclusion, all
//     handled in `getIndustryOrientationFactor`.
//   - INDUSTRY_PROJECT_TYPE_FACTORS maps the `IndustryProjectType`
//     enum to its factor value.
//
// We avoid putting the exclusion logic in the data tables; the rule
// `RULES_INDUSTRIAL.md §2 规则 1/3 and §3 规则 1/2` lives in the
// helpers in src/logic/factor-helpers.ts.

import type { IndustryProjectType } from "../types/enums.js";

/**
 * Orientation factor:
 *   - `qualified` (战略性新兴产业、优势传统产业、生产性现代服务业) = 0.5
 *   - `other` (其他产业) = 1
 *
 * The caller decides which branch to take based on
 * `BuildingItem.isIndustryOriented`. The table itself is just the
 * numeric map.
 */
export const INDUSTRY_ORIENTATION_FACTORS = {
  qualified: 0.5,
  other: 1,
} as const;

/**
 * Project-type factor (RULES_INDUSTRIAL.md §3).
 *
 * 重点产业项目 / 联合申请 = 0.6
 * 重点产业项目 / 单一意向单位 = 0.7
 * 总部项目 = 0.7
 * 一般产业项目 = 1
 *
 * Items without an `industryProjectType` are treated as `一般产业项目`
 * (factor 1) by the caller.
 */
export const INDUSTRY_PROJECT_TYPE_FACTORS: Readonly<
  Record<IndustryProjectType, number>
> = {
  "重点产业项目-联合申请": 0.6,
  "重点产业项目-单一意向单位": 0.7,
  "一般产业项目": 1,
  "总部项目": 0.7,
};
